import { useState } from 'react';
import gettext from '@sdk/lang/gettext';

import BookCall from '@web/components/survey/BookCall';
import SurveyStep from '@web/components/survey/SurveyStep';
import SurveyCommentStep from '@web/components/survey/SurveyCommentStep';
import {
  SLING_STEPS_CONFIG,
  TOAST_STEPS_CONFIG,
  SurveySteps,
  BOOK_CALL_URL,
  STEPS_COUNT,
  SLING_REASON_OPTIONS,
  TOAST_REASON_OPTIONS,
} from '@web/components/subscriptionPreferenceSurvey/constants';
import { SurveyReasonStep } from '@web/components/survey/SurveyReasonStep/SurveyReasonStep';

type Props = {
  reason: string;
  setReason: (reason: string) => void;
  other: string;
  setOther: (other: string) => void;
  comment: string;
  setComment: (comment: string) => void;
  submitForm: VoidFunction;
  isToastBilling: boolean;
  onClose: VoidFunction;
};

const SubscriptionPreferenceSteps = ({
  reason,
  setReason,
  other,
  setOther,
  comment,
  setComment,
  submitForm,
  isToastBilling,
  onClose,
}: Props) => {
  const [step, setStep] = useState(SurveySteps.reason);
  const reasonOptions = isToastBilling ? TOAST_REASON_OPTIONS : SLING_REASON_OPTIONS;
  const stepConfigs = isToastBilling ? TOAST_STEPS_CONFIG : SLING_STEPS_CONFIG;

  const nextStep = () => {
    setStep((step) => {
      step += 1;

      if (step === SurveySteps.finishCall) {
        submitForm();
      }

      return step;
    });
  };

  if (step === SurveySteps.reason) {
    const currentStep = stepConfigs[SurveySteps.reason];
    return (
      <SurveyReasonStep
        reason={reason}
        setReason={setReason}
        submitStep={nextStep}
        other={other}
        setOther={setOther}
        stepNumber={currentStep.number}
        stepsCount={STEPS_COUNT}
        reasonOptions={reasonOptions}
        subtitle={currentStep.subtitle}
      />
    );
  }

  if (step === SurveySteps.comment) {
    const currentStep = stepConfigs[SurveySteps.comment];
    return (
      <SurveyCommentStep
        comment={comment}
        setComment={setComment}
        submitStep={nextStep}
        stepsCount={STEPS_COUNT}
        stepNumber={currentStep.number}
        text={gettext(currentStep.text)}
        submitLabel={gettext(currentStep.submitLabel)}
        isCommentRequired={false}
      />
    );
  }

  if (step === SurveySteps.finishCall) {
    return (
      <SurveyStep>
        <BookCall bookCallUrl={BOOK_CALL_URL} onClose={onClose} />
      </SurveyStep>
    );
  }

  return null;
};

export default SubscriptionPreferenceSteps;
